import React, { ReactNode, useEffect, useMemo, useState } from "react";
import {
  Typography,
  Grid,
  Tab,
  TextField,
  InputAdornment,
} from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import { Pie, PieChart, Cell, ResponsiveContainer, Tooltip } from "recharts";
import GoogleMapApi from "../../IotComponent/GoogleMapIotTracker/Maps";
import AppHeader from "../../../../common/Pages/AppHeader/AppHeader";
import FleetDailySummaryTable from "./fleet-daily-summary-report";
import { FleetDashboardOverviewApi } from "../../../../API/Iot-Api/FleetDashboardOverview/FleetDashobardOverview";
import { AllFleetSummaryResponse } from "../../../../@Types/DRO/IotApiResponse/FleetOverviewResponse";
import "./style.css";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { TabContext, TabList, TabPanel } from "@mui/lab";

const FleetDashboard = () => {
  const COLORS = [
    "#06B681",
    "#0079FF",
    "#FF9500",
    "#FFBB0D",
    "#FE6151",
    "#ACACAC",
  ];

  const categoryLabels: Record<string, string> = {
    total: "Total Fleets",
    running: "On Ride",
    stopped: "On Pause",
    immobilized: "Immobilized",
    gps_disconnected: "No GPS Connected",
    offline: "IOT Disconnected",
    alarm: "Alarm",
  };

  
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [fleetSummary, setFleetSummary] =
    useState<AllFleetSummaryResponse | null>(null);
  const [searchValInput, setSearchValInput] = useState("");
  const [submittedSearchValue, setSubmittedSearchValue] = useState("");
  const getRandomColor = (index: number) => COLORS[index % COLORS.length];

  const handleChipDelete = (value: never) => {
    setSelectedOptions(selectedOptions.filter((option) => option !== value));
  };

  const getOptionLabel = (value: number) => `Option ${value}`;
  const [tabIndex, setTabIndex] = useState(0);
  const currentTabIndex = useMemo(() => tabIndex, [tabIndex]);

  const handleTabChange = (event: any, newValue: any) => {
    setTabIndex(newValue);
  };

  useEffect(() => {
    const timerId = setTimeout(() => {
      console.log("set", { searchValInput });
      setSubmittedSearchValue(searchValInput);
    }, 500);
    return () => {
      console.log("cleared");
      clearTimeout(timerId);
    };
  }, [searchValInput]);
  useEffect(() => {
    const fetchFleetSummary = async () => {
      try {
        const data: AllFleetSummaryResponse =
          await FleetDashboardOverviewApi.api.getAllFleetSummary();
        setFleetSummary(data);
      } catch (error) {
        console.error("Error fetching fleet summary", error);
      }
    };

    fetchFleetSummary();
  }, []);

  const fleetCategories: Record<
    string,
    {
      [x: string]: any;
      label: string;
      icon: string;
    }
  > = {
    total: {
      label: "All Fleets",
      icon: "../../../../assets/line-icon/black-line.svg",
    },
    running: {
      label: "On Ride",
      icon: "../../../../assets/line-icon/green-line.svg",
    },
    stopped: {
      label: "On Pause",
      icon: "../../../../assets/line-icon/blue-line.svg",
    },
    immobilized: {
      label: "Immobilized",
      icon: "../../../../assets/line-icon/orange-line.svg",
    },
    gps_disconnected: {
      label: "No GPS Connected",
      icon: "../../../../assets/line-icon/yellow-line.svg",
    },
    offline: {
      label: "IOT Disconnected",
      icon: "../../../../assets/line-icon/grey-line.svg",
    },
    alarm: {
      label: "Alarm",
      icon: "../../../../assets/line-icon/red-line.svg",
    },
  };
  const handleClearSearch = () => {
    setSearchValInput("");
  };

  const FleetDailySummaryMap = () => {
    return (
      <div className="flex-grow h-[450px] w-full bg-[#fff] m-2 font-rubik relative">
        <div className="flex justify-between items-center border-b pt-3">
          <div>
            <h2 className="text-center mx-1 mt-1 font-bold ml-5 text-base text-[#263238] pb-2">
              IOT Status {Object.keys(fleetCategories)[currentTabIndex]}
            </h2>
          </div>
          <div className="flex mr-4 mb-4">
            <div className="flex w-full justify-end">
              <div className="mr-3">
                <TextField
                  placeholder="EB Number & User Id"
                  id="outlined-basic"
                  variant="outlined"
                  onChange={(search: any) =>
                    setSearchValInput(search.target.value)
                  }
                  value={searchValInput}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment
                        position="end"
                        onClick={handleClearSearch}>
                        <ClearIcon style={{ cursor: "pointer" }} />
                      </InputAdornment>
                    ),
                    style: { height: "40px", borderRadius: "25px" },
                  }}
                  // onKeyDown={handleKeyPress}
                />
              </div>
            </div>
          </div>
        </div>

        <div style={{ width: "100%", height: "23rem" }}>
          <GoogleMapApi
            searchQrCode={submittedSearchValue}
            category={Object.keys(fleetCategories)[currentTabIndex]} // Pass category
          />
        </div>
      </div>
    );
  };
  return (
    <>
      <AppHeader />
      <div className="flex justify-evenly bg-[#D8FFEA] px-2  pt-8 pb-4"></div>
      <div className="flex bg-[#D8FFEA] px-12 py-2">
        <div className="flex justify-evenly">
          {selectedOptions?.map((value) => (
            <div
              key={value}
              className="border-[1px] flex items-center justify-between rounded-full px-2 py-1 border-[#00CB60] text-[#00CB60] mr-3">
              {getOptionLabel(parseInt(value, 10))}
              <button onClick={() => handleChipDelete(value)}>
                <img
                  alt="track-icon"
                  src="/assets/hyper-track-icon/cross.svg"
                  className="ml-2"
                />
              </button>
            </div>
          ))}
        </div>
      </div>
      <TabContext value={currentTabIndex.toString()}>
      <div className="bg-slate-100 font-rubik text-sm  px-4">
          <div className="flex bg-white rounded-lg relative bottom-3">
            {fleetSummary ? (
              <>
                <TabList
                  onChange={handleTabChange}
                  centered
                  indicatorColor="primary"
                  textColor="primary"
                  sx={{
                    "& .MuiTab-root": {
                      textTransform: "none",
                      fontWeight: "bold",
                    },
                    "& .Mui-selected": { color: "#06B681" },
                  }}>
                  {fleetSummary.data.summary_metrics.map(
                    ({ category, count }, index) => {
                      const fleetData = fleetCategories[category]; // Now TypeScript recognizes the keys
                      if (!fleetData) return null; // Skip if category is not found

                      return (
                        <Tab
                          key={category}
                          value={index.toString()} // 🔐 Add this line
                          label={
                            <div className="flex-grow rounded-2xl bg-gradient-to-r text-black p-4">
                              <div className="flex text-left">
                                <div>
                                  <img
                                    src={fleetData.icon}
                                    alt=""
                                    className="h-16"
                                  />
                                </div>
                                <div className="pl-2">
                                  <p className="font-medium text-[#727597] text-sm">
                                    {fleetData.label}
                                  </p>
                                  <p className="font-semibold text-[#1E1E1E] text-4xl mt-2">
                                    {count || 0}
                                  </p>
                                </div>
                              </div>
                            </div>
                          }
                        />
                      );
                    }
                  )}
                </TabList>
              </>
            ) : (
              <p>Loading...</p>
            )}
          </div>
        </div>
        <div className="bg-slate-100 font-rubik text-sm">
          <TabPanel value='0'>
            <div className="w-full px-4 bg-[#fff] rounded-lg shadow py-4">
              <div className="flex justify-between items-center border-b">
                <div>
                  <h2 className="text-center mx-1 mt-1 font-bold ml-5 text-base text-[#263238] pb-2">
                    IOT Status
                  </h2>
                </div>
                <div className="flex mr-4 mb-4">
                  <div className="flex w-full justify-end">
                    <div className="mr-3">
                      <TextField
                        placeholder="EB Number & User Id"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={(search: any) =>
                          setSearchValInput(search.target.value)
                        }
                        value={searchValInput}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment
                              position="end"
                              onClick={handleClearSearch}>
                              <ClearIcon style={{ cursor: "pointer" }} />
                            </InputAdornment>
                          ),
                          style: { height: "40px", borderRadius: "25px" },
                        }}
                        // onKeyDown={handleKeyPress}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full flex">
                <div className="flex-grow w-2/6	m-4">
                  <div className="px-2">
                    <ResponsiveContainer width="100%" height={360}>
                      <PieChart>
                        <Pie
                          data={fleetSummary?.data.summary_metrics?.slice(1)} // Exclude the first object
                          cx="50%"
                          cy="50%"
                          innerRadius="40%" // Adjusted for better visibility
                          outerRadius="80%" // Adjusted for better visibility
                          paddingAngle={4} // Increased padding for better separation
                          minAngle={20} // Minimum angle for visibility
                          dataKey="count"
                          nameKey="category"
                          isAnimationActive={false}>
                          {fleetSummary?.data.summary_metrics
                            ?.slice(1)
                            .map((entry: any, index: number) =>
                              entry.count > 0 ? ( // Skip color assignment if count is 0
                                <Cell
                                  style={{ outline: "none" }}
                                  stroke="none"
                                  key={`cell-${index}`}
                                  fill={getRandomColor(index)}
                                />
                              ) : null
                            )}
                        </Pie>
                        <Tooltip
                          formatter={(value: number, name: string) => [
                            `${value}`,
                            `${categoryLabels[name] || name}`,
                          ]}
                        />
                        <text
                          x="50%"
                          y="50%"
                          textAnchor="middle"
                          dominantBaseline="middle"
                          className="text-xl font-bold">
                          Total Fleets
                        </text>
                        <text
                          x="50%"
                          y="60%"
                          textAnchor="middle"
                          dominantBaseline="middle"
                          className="text-2xl font-bold">
                          {fleetSummary?.data.summary_metrics
                            .filter((entry: any) => entry.category === "total")
                            .reduce(
                              (acc: number, entry: any) => acc + entry.count,
                              0
                            )}
                        </text>
                      </PieChart>
                    </ResponsiveContainer>
                  </div>
                </div>
                <div className="flex-grow h-96 w-4/6	 bg-[#fff] m-2 font-rubik relative">
                  <div style={{ width: "100%", height: "23rem" }}>
                    <GoogleMapApi
                      searchQrCode={submittedSearchValue}
                      category={Object.keys(fleetCategories)[currentTabIndex]} // Pass category
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* { Creating second div elements for card view } */}
            <div className="mt-4">
              <FleetDailySummaryTable
                searchQrCode={submittedSearchValue}
                category={Object.keys(fleetCategories)[currentTabIndex]}
              />
            </div>
          </TabPanel>
          <TabPanel value='1'>
            <FleetDailySummaryMap />
            <FleetDailySummaryTable
              searchQrCode={submittedSearchValue}
              category={Object.keys(fleetCategories)[currentTabIndex]}
            />
          </TabPanel>
          <TabPanel value='2'>
            <FleetDailySummaryMap />
            <FleetDailySummaryTable
              searchQrCode={submittedSearchValue}
              category={Object.keys(fleetCategories)[currentTabIndex]}
            />
          </TabPanel>
          <TabPanel value='3'>
            <FleetDailySummaryMap />
            <FleetDailySummaryTable
              searchQrCode={submittedSearchValue}
              category={Object.keys(fleetCategories)[currentTabIndex]}
            />
          </TabPanel>
          <TabPanel value='4'>
            <FleetDailySummaryMap />
            <FleetDailySummaryTable
              searchQrCode={submittedSearchValue}
              category={Object.keys(fleetCategories)[currentTabIndex]}
            />
          </TabPanel>
          <TabPanel value='5'>
            <FleetDailySummaryMap />
            <FleetDailySummaryTable
              searchQrCode={submittedSearchValue}
              category={Object.keys(fleetCategories)[currentTabIndex]}
            />
          </TabPanel>
          <TabPanel value='6'>
            <FleetDailySummaryMap />
            <FleetDailySummaryTable
              searchQrCode={submittedSearchValue}
              category={Object.keys(fleetCategories)[currentTabIndex]}
            />
          </TabPanel>
          <h3 className="text-center mb-3">
          © 2025 Powered by Zypp Electric
        </h3>
        </div>
      </TabContext>
    </>
  );
};

export default FleetDashboard;
